/* eslint-disable no-unused-vars */
import { Button, Grid, Typography } from "@mui/material";
import PDatePicker from "../../../../components/pos/PDatePicker";
import PFileUploader from "../../../../components/pos/PFileUploader";
import PSelect from "../../../../components/pos/PSelect";
import PText from "../../../../components/pos/PText";
import db from "../../../../db/db";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { StringUtils } from "../../../../utils/StringUtils";

export default function QuickPurchaseRequestOrderDetails(props) {
  const { t } = useTranslation();
  const translate = t;
  const [refereneNumber, setReferenenumber] = useState("AUTO");
  const [refereneNumberError, setReferenenumberError] = useState("");
  const [vendor, setVendor] = useState("");
  const [vendorError, setVendorError] = useState("");
  const [vendorOptions, setVendorOptions] = useState([]);
  const [paymentMode, setPaymentmode] = useState({
    name: "CREDIT",
    id: "CREDIT",
  });
  const [paymentModeError, setPaymentmodeError] = useState("");
  const [paymentTerms, setPaymentterms] = useState("");
  const [paymentTermsError, setPaymenttermsError] = useState("");
  const [paymentTermsOptions, setPaymenttermsOptions] = useState([]);
  const [accountOptions, setAccountOptions] = useState([]);
  const [expectedDate, setExpectedDate] = useState("");
  const [expectedDateError, setExpectedDateError] = useState("");
  const [transactionDate, setTransactionDate] = useState("");
  const [transactionDateError, setTransactionDateError] = useState("");
  const [note, setNote] = useState("");
  const [attachmentName, setAttachmentName] = useState(null);
  const [liveValidation, setLiveValidation] = useState(false);
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [invoiceNumberError, setInvoiceNumberError] = useState("");

  useEffect(() => {
    populateVendor();
    setPaymenttermsOptions([
      { name: "7 DAYS", id: 1 },
      { name: "10 DAYS", id: 6 },
      { name: "15 DAYS", id: 2 },
      { name: "30 DAYS", id: 3 },
      { name: "45 DAYS", id: 7 },
      { name: "60 DAYS", id: 8 },
      { name: "90 DAYS", id: 4 },
      { name: "100 DAYS", id: 5 },
    ]);
  }, []);

  useEffect(() => {
    if (props.purchaseOrderObj != null) populateData(props.purchaseOrderObj);
  }, [props.purchaseOrderObj]);

  useEffect(() => {
    if (paymentMode.id != "CREDIT") setPaymentterms("");
  }, [paymentMode]);

  const paymentModeOptions = [
    { name: "CREDIT", id: "CREDIT" },
    { name: "CASH", id: "CASH" },
    { name: "BANK", id: "BANK" },
  ];

  var biRef = {};

  props.biRef.requestDraftCrud = {
    parentEvent: parentEvent,
  };

  function parentEvent(eventType, val1) {
    if (eventType == "getPayload") return createPayload(false);
    if (eventType == "getDraftPayload") return createPayload(true);
    if (eventType == "resetFileds") resetFields();
    if (eventType == "validation") {
      for (var i = 0; i < val1.messageList.length; i++) {
        var obj = val1.messageList[i];
        if (obj.field === "invoiceNo") {
          setInvoiceNumberError(obj.message);
        }
      }
    }
  }

  function populateData(inputData) {
    setReferenenumber(inputData.orderId);
    setVendor({
      id: inputData.vendorId,
      name: inputData.displayVendorName,
      bean: inputData.vendorBean,
    });
    setPaymentmode({
      name: inputData.paymentMode,
      id: inputData.paymentModeId,
    });
    setPaymentterms({
      name: inputData.paymentTerms,
      id: inputData.paymentTermsId,
    });
    setTransactionDate(inputData.date);
    setNote(inputData.notes);
    setAttachmentName(inputData.filename);
    setExpectedDate(inputData.expectedDate);
    setInvoiceNumber(inputData.invoiceNumber ? inputData.invoiceNumber : "");
  }

  function resetFields() {
    setReferenenumber("AUTO");
    setReferenenumberError("");
    setVendor(null);
    setVendorError("");
    setPaymentmode({ name: "CREDIT", id: "CREDIT" });
    setPaymentmodeError("");
    setPaymentterms("");
    setPaymenttermsError("");
    setTransactionDate("");
    setTransactionDateError("");
    setNote("");
    setAttachmentName(null);

    setLiveValidation(false);
  }

  function createPayload(skipValidation) {
    if (skipValidation || validate()) {
      let saveObject = Object.create(null);
      saveObject["orderId"] = refereneNumber;
      saveObject["vendorId"] = vendor.id;
      saveObject["vendorBean"] = vendor.bean;
      saveObject["date"] = StringUtils.getIsoDate(transactionDate);
      saveObject["expectedDate"] = StringUtils.getIsoDate(expectedDate);
      saveObject["notes"] = note;
      saveObject["paymentMode"] = paymentMode.name;
      saveObject["paymentTerms"] = paymentTerms.name;
      saveObject["paymentModeId"] = paymentMode.id;
      saveObject["paymentTermsId"] = paymentTerms.id;
      saveObject["isQuickEntry"] = false;
      saveObject["invoiceNumber"] = invoiceNumber;
      saveObject["settlementDate"] = null;
      saveObject["settlementNote"] = null;
      saveObject["fileName"] = attachmentName;
      return saveObject;
    } else return null;
  }

  function validate() {
    let flag = true;
    if (!refereneNumber || refereneNumber === "") {
      setReferenenumberError(translate("Reference number is required"));
      flag = false;
    }
    if (!vendor || vendor === undefined) {
      setVendorError(translate("Vendor is required"));
      flag = false;
    }
    if (!paymentMode || paymentMode === "") {
      setPaymentmodeError(translate("Payment mode is required"));
      flag = false;
    } else if (paymentMode.id === "CREDIT") {
      if (!paymentTerms || paymentTerms === undefined) {
        setPaymenttermsError(translate("Payment terms is required"));
        flag = false;
      }
    }
    if (!transactionDate || transactionDate === "") {
      setTransactionDateError(translate("Transaction date is required"));
      flag = false;
    }
    if (!expectedDate || expectedDate === "") {
      setExpectedDateError(translate("Expected date is required"));
      flag = false;
    }
    return flag;
  }

  useEffect(() => {
    if (liveValidation && refereneNumber === "")
      setReferenenumberError(translate("Referenenumber is Required"));
    else setReferenenumberError("");
  }, [refereneNumber]);
  useEffect(() => {
    if (liveValidation && vendor === "")
      setVendorError(translate("Vendorbean is Required"));
    else setVendorError("");
  }, [vendor]);
  useEffect(() => {
    if (liveValidation && paymentMode === "")
      setPaymentmodeError(translate("Paymentmode is Required"));
    else setPaymentmodeError("");
  }, [paymentMode]);
  useEffect(() => {
    if (liveValidation && paymentTerms === "")
      setPaymenttermsError(translate("Paymentterms is Required"));
    else setPaymenttermsError("");
  }, [paymentTerms]);

  function handleUploadFile() {
    biRef.fileUpload.showPFileUploader(
      "Purchase request attachment",
      "/api/v1/upload/purchaseorder/file"
    );
  }

  function handleViewFile() {
    console.log("Inside view file");
  }

  function onFileSelected(fileName) {
    setAttachmentName(fileName);
  }

  async function populateVendor() {
    db.vendor.toArray(function (data) {
      let dat = [];
      for (let i = 0; i < data.length; i++) {
        if (!data[i].parent_id) {
          dat.push({ id: data[i].id, name: data[i].name, bean: data[i] });
        }
      }
      setVendorOptions(dat);
    });
  }

  return (
    <div>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={3}>
          <table width="100%">
            <tbody>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Ref. No")}
                  </Typography>
                </td>
                <td>
                  <PText
                    readOnly={true}
                    value={refereneNumber}
                    error={refereneNumberError}
                    InputProps={{ readOnly: true }}
                    onChange={(e) => setReferenenumber(e.target.value)}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Exp. Date")}
                  </Typography>
                </td>
                <td>
                  <PDatePicker
                    defaultValue="2020-08-23"
                    value={expectedDate}
                    error={expectedDateError}
                    onChange={(value) => setExpectedDate(value)}
                  ></PDatePicker>
                </td>
              </tr>
            </tbody>
          </table>
        </Grid>
        <Grid item xs={12} sm={4}>
          <table width="100%">
            <tbody>
              <tr>
                <td>
                  <Typography variant="body1">{translate("Vendor")}</Typography>
                </td>
                <td>
                  <PSelect
                    options={vendorOptions}
                    value={vendor}
                    errorMessage={vendorError}
                    onChange={(event, newValue) => {
                      setVendor(newValue);
                      if (
                        newValue.bean &&
                        newValue.bean.paymentModeId &&
                        newValue.bean.paymentMode
                      ) {
                        setPaymentmode({
                          name: newValue.bean.paymentMode,
                          id: newValue.bean.paymentModeId,
                        });
                      }
                      if (
                        newValue.bean &&
                        newValue.bean.paymentTermsId &&
                        newValue.bean.paymentTerms
                      ) {
                        setPaymentterms({
                          name: newValue.bean.paymentTerms,
                          id: newValue.bean.paymentTermsId,
                        });
                      }
                    }}
                  ></PSelect>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">{translate("Note")}</Typography>
                </td>
                <td>
                  <PText
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                  ></PText>
                </td>
              </tr>
            </tbody>
          </table>
        </Grid>
        <Grid item xs={12} sm={3}>
          <table width="100%">
            <tbody>
              <tr>
                <td>
                  <Typography variant="body1">{translate("Mode")}</Typography>
                </td>
                <td>
                  <PSelect
                    options={paymentModeOptions}
                    value={paymentMode}
                    errorMessage={paymentModeError}
                    onChange={(event, newValue) => {
                      setPaymentmode(newValue);
                    }}
                  ></PSelect>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">{translate("Date")}</Typography>
                </td>
                <td>
                  <PDatePicker
                    defaultValue="2020-08-23"
                    value={transactionDate}
                    error={transactionDateError}
                    onChange={(value) => {
                      setTransactionDate(value);
                    }}
                  ></PDatePicker>
                </td>
              </tr>
            </tbody>
          </table>
        </Grid>
        <Grid item xs={12} sm={2}>
          <table width="100%">
            <tbody>
              <tr>
                <td>
                  <Typography variant="body1">{translate("Terms")}</Typography>
                </td>
                <td>
                  <PSelect
                    options={paymentTermsOptions}
                    disabled={
                      paymentMode == null || paymentMode.id == "CREDIT"
                        ? false
                        : true
                    }
                    value={paymentTerms}
                    errorMessage={paymentTermsError}
                    onChange={(event, newValue) => {
                      setPaymentterms(newValue);
                    }}
                  ></PSelect>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">{translate("File")}</Typography>
                </td>
                <td>
                  <Button onClick={handleUploadFile} color="primary">
                    {attachmentName != null ? "Change" : "Upload"}
                  </Button>
                  {attachmentName != null && (
                    <Button onClick={handleViewFile} color="primary">
                      {translate("View")}
                    </Button>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </Grid>
      </Grid>
      <PFileUploader biRef={biRef} onFileSelected={onFileSelected} />
    </div>
  );
}
